import { getAmplitudeInstance } from '../amplitudeHelpers';

/**
 * The user taps the dropdown menu on the Explore map to open the heatmap filter menu.
 */
const logHeatmapFilterMenuTapped = (callback?: () => void) => {
  getAmplitudeInstance().logEvent('heatmap filter menu tapped', {}, callback);
};

export default logHeatmapFilterMenuTapped;
